import { render, staticRenderFns } from "./MultipleSpecs.vue?vue&type=template&id=40397c00&scoped=true"
import script from "./MultipleSpecs.vue?vue&type=script&lang=js"
export * from "./MultipleSpecs.vue?vue&type=script&lang=js"
import "./MultipleSpecs.vue?vue&type=style&index=0&id=40397c00&prod&lang=stylus&scoped=true"
import "./MultipleSpecs.vue?vue&type=style&index=1&id=40397c00&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40397c00",
  null
  
)

export default component.exports